import React, { memo, useEffect, useRef } from "react"

import { graphql, useStaticQuery } from "gatsby"

import { isLive } from "@utils/config"
import { listToTree, sortAscending } from "@utils/general"

import { NavbarDesktop } from "./navbar-desktop"
import { NavbarMobile } from "./navbar-mobile"

import * as styles from "./navbar.module.css"

const Navbar = memo(({ location }) => {
  const menusData = useStaticQuery(graphql`
    {
      allMainNavigation {
        nodes {
          id
          name
          parentId
          link
          color
          mobileColor
          backgroundColor
          forTesting
          mainNavigationId
          sortOrder
          alignment
        }
      }
      allNavigationMenu(
        sort: { sortOrder: ASC }
        filter: { location: { eq: "TOP_BANNER" }, status: { eq: "PUBLISHED" } }
      ) {
        nodes {
          sortOrder
          name
          link
          id
        }
      }
    }
  `)

  const menuLinks = menusData?.allNavigationMenu?.nodes || []
  const mainLinks = menusData?.allMainNavigation?.nodes || []

  let mainLinksData = mainLinks.map((node) => {
    return {
      ...node,
      id: node.mainNavigationId,
    }
  })

  if (isLive()) {
    mainLinksData = mainLinksData.filter((node) => node.forTesting !== true)
  }
  mainLinksData = sortAscending(listToTree(mainLinksData), "sortOrder")

  let menuLinksData = []
  menuLinksData = menuLinks.map((node) => {
    return {
      ...node,
      parentId: null,
    }
  })
  menuLinksData = sortAscending(listToTree(menuLinksData), "sortOrder")

  const mobileLinks = [...mainLinksData, ...menuLinksData]

  // Publish the sticky header's height as a CSS variable so that other sticky
  // elements (e.g. the product page image gallery) can offset themselves and
  // sit below the navbar instead of underneath it.
  const containerRef = useRef(null)
  useEffect(() => {
    const el = containerRef.current
    if (!el) {
      return undefined
    }
    const setHeight = () => {
      document.documentElement.style.setProperty(
        "--sticky-header-height",
        `${el.offsetHeight}px`
      )
    }
    setHeight()
    const observer = new ResizeObserver(setHeight)
    observer.observe(el)
    return () => observer.disconnect()
  }, [])

  return (
    <div className={styles.container} ref={containerRef}>
      <NavbarMobile navigationList={mobileLinks} location={location} />
      <NavbarDesktop
        mainLinks={mainLinksData}
        menuLinks={menuLinks}
        location={location}
      />
    </div>
  )
})

export default Navbar
